import React, { ReactNode, useEffect, useId } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface SheetProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}
export function Sheet({
  open,
  onClose,
  title,
  subtitle,
  children,
  footer
}: SheetProps) {
  const reduce = useReducedMotion();
  const titleId = useId();
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  return <AnimatePresence data-id="element-1288" data-mp="2sq2fy120emlc">
      {open && <div className="fixed inset-0 z-50 flex items-end justify-center md:items-center md:p-6" data-id="element-1289" data-mp="c2zz66oklhya">
          <motion.div className="absolute inset-0 bg-ink/40" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} aria-hidden="true" data-id="element-1290" data-mp="81err0ut1vvh" />
          <motion.div role="dialog" aria-modal="true" aria-labelledby={titleId} className="relative flex max-h-[92vh] w-full flex-col overflow-hidden rounded-t-3xl bg-surface shadow-sheet md:max-w-lg md:rounded-3xl" initial={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 32
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 24
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-1291" data-mp="tb5qa16qf871">
            <div className="mx-auto mt-2 h-1 w-10 rounded-full bg-line md:hidden" aria-hidden="true" data-id="element-1292" data-mp="fbxk2oc5iztc" />
            <div className="flex items-start justify-between gap-4 px-5 pb-3 pt-4" data-id="element-1293" data-mp="3e267c9l8ftoq">
              <div className="min-w-0" data-id="element-1294" data-mp="3j07mijfjf8ux">
                <h2 id={titleId} className="text-lg font-extrabold leading-tight" data-id="element-1295" data-mp="3iywlgrdh8f7i">
                  {title}
                </h2>
                {subtitle && <p className="mt-0.5 text-sm text-muted" data-id="element-1296" data-mp="l6xkfrbo38zn">{subtitle}</p>}
              </div>
              <button type="button" onClick={onClose} aria-label="Zapri" className="-mr-2 -mt-1 grid h-10 w-10 shrink-0 place-items-center rounded-full text-muted transition-colors duration-150 hover:bg-canvas hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent" data-id="element-1297" data-mp="l538v3mact88">
                <XIcon className="h-5 w-5" data-id="element-1298" data-mp="2a4sbye8ke6w" />
              </button>
            </div>
            <div className="overflow-y-auto px-5 pb-5" data-id="element-1299" data-mp="g9e6ksivsy88">{children}</div>
            {footer && <div className="border-t border-line bg-surface px-5 py-4" data-id="element-1300" data-mp="b7oy9kn1mynu">{footer}</div>}
          </motion.div>
        </div>}
    </AnimatePresence>;
}